import { useState } from 'react';
import Breadcrumb from '../Common/Breadcrumb';
import CMSTab from './CMSTab';
import JobFunction from './JobFunction';
import Carousal from './Carousal';
import Site from './Site';
import SearchForm from './Search-Form';

export default function CMS_Setting() {
  const [activeTab, setActiveTab] = useState('jobFunction');

  const tabList = [
    {
      name: 'Job Function',
      setter: 'setJobFunction',
      value: 'jobFunction',
    },
    {
      name: 'Carousel',
      setter: 'setCarousel',
      value: 'carousel',
    },
    {
      name: 'Site Setting',
      setter: 'setSiteSetting',
      value: 'siteSetting',
    },
    {
      name: 'Search Form',
      setter: 'setSearchForm',
      value: 'searchForm',
    },
  ];
  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <div className="row">
          <div className="col-xl-12 col-sm-12 col-12 mb-4">
            <Breadcrumb page={'CMS Setting'} />
          </div>
          <div className="col-xl-12 col-sm-12 col-12 mb-4">
            <CMSTab list={tabList} activeTab={activeTab} setActiveTab={setActiveTab} />
          </div>
          <div className="col-xl-12 col-sm-12 col-12 mb-4">
            {activeTab === 'jobFunction' && <JobFunction />}
            {activeTab === 'carousel' && <Carousal />}
            {activeTab === 'siteSetting' && <Site />}
            {activeTab === 'searchForm' && <SearchForm />}
          </div>
        </div>
      </div>
    </div>
  );
}
